import { inject, Service } from '@angular/core';
import { Store } from '@ngrx/store';
import { selectLoaded, selectLoading, selectLookup, selectLookupLoaded, selectLookupOptions, selectRoles, selectTotal } from '../selectors/roles.selector';
import { rolesActions } from '../actions/roles.actions';
import { GetRolesValue } from '../models';

@Service()
export class RolesFacade {
    private readonly store = inject(Store);

    readonly roles = this.store.selectSignal(selectRoles);
    readonly loaded = this.store.selectSignal(selectLoaded);
    readonly loading = this.store.selectSignal(selectLoading);
    readonly total = this.store.selectSignal(selectTotal);
    readonly lookupLoaded = this.store.selectSignal(selectLookupLoaded);
    readonly lookup = this.store.selectSignal(selectLookup);
    readonly lookupOptions = this.store.selectSignal(selectLookupOptions);

    getRoles(value: GetRolesValue): void {
        this.store.dispatch(rolesActions.getRoles({ value }));
    }

    getRolesLookup(): void {
        this.store.dispatch(rolesActions.getRolesLookup());
    }

    clear(): void {
        this.store.dispatch(rolesActions.clear());
    }
}
